import script from "./ContentCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentCard.vue?vue&type=script&setup=true&lang=ts"

import "./ContentCard.vue?vue&type=style&index=0&id=fadfd41c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fadfd41c"]])

export default __exports__